export default __webpack_public_path__ + "static/media/jbc_1_jpeg.0e40c627.jpg";